export enum Role {
    Admin = 'Admin',
    Employee = 'Employee',
    ContentCreator = 'ContentCreator',
    Employer = 'Employer',
    Supplier = 'Supplier',
    Provider = 'Provider'
}
